import { listarUsersAdminService } from './../services/listarUsersAdminService';
import { URL_API } from './../../../constants';
import { LIST_USERS_ADMIN } from './../../../constants';
import { createAction } from 'redux-actions';

export const listarUsersAdminAction = createAction(LIST_USERS_ADMIN,
  (token) => listarUsersAdminService(URL_API, token)());
